import { PackageType } from '~shared/types/pricing/package';

export enum LegaleseDisclaimer {
  TeamsDiscount = 'DISPLAYED_PRICING',
  OverageCost = 'PER_ADDITIONAL_RESPONSE',
  EnterpriseAddons = 'ADD_ON_FEATURES',
  // TODO @Johny this will be added back after checking with PM
  TeamsOfferExpiry = 'TEAMS_DISCOUNT_DISCLAIMER',
}

export default {
  [PackageType.Teams]: [
    LegaleseDisclaimer.TeamsDiscount,
    LegaleseDisclaimer.OverageCost,
    LegaleseDisclaimer.EnterpriseAddons,
    LegaleseDisclaimer.TeamsOfferExpiry,
  ],
  [PackageType.Individual]: [LegaleseDisclaimer.OverageCost, LegaleseDisclaimer.TeamsOfferExpiry],
  [PackageType.Educational]: [LegaleseDisclaimer.OverageCost],
};
